import React from 'react';

/**
 * Label-over-content field used inside Card bodies.
 *
 *   <Field label="Project name">
 *     <InlineEdit ... />
 *   </Field>
 *
 * Props:
 *   label    — eyebrow label above the content (11px / 500 / text-3)
 *   hint     — optional helper text below the content (10.5px / text-4)
 *   side     — optional inline-right slot rendered alongside the label
 *              (useful for status pills next to the label)
 */
export default function Field({ label, hint, side, children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
      {(label || side) && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 12.5,
            fontWeight: 500,
            letterSpacing: '0.02em',
            color: 'var(--text-3)',
          }}
        >
          <span>{label}</span>
          {side && <span style={{ marginLeft: 'auto' }}>{side}</span>}
        </div>
      )}
      {children}
      {hint && (
        <div style={{ fontSize: 12, color: 'var(--text-4)', lineHeight: 1.4 }}>
          {hint}
        </div>
      )}
    </div>
  );
}
